module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 10
// module chunks = 0 1